import { createSlice, configureStore } from "@reduxjs/toolkit";


const pageSlicer = createSlice({
    name: 'page',
    initialState: {
        value: false,
    },
    reducers: {
        setTrue: (state) => {
            state.value = true
        },
        setFalse: (state) => {
            state.value = false
        }
    }
})

export const { increment, decrement } = pageSlicer.actions;

export default pageSlicer.reducer;